module.exports = __webpack_public_path__ + "media/newstyle/images/amex-dc8ac6579257da63a6fbf852cd31703d.svg";